import { driver } from 'driver.js';
import app from '$$app';
import routerHelper from '$$routerHelper';

const __ = window.__;

function startIntro() {
  const driverObj = driver({
    popoverClass: 'gp-driver-popover',
    animate: true,
    stagePadding: 5,
    showProgress: false,
    showButtons: ['next'],
    doneBtnText: __('header-toolbar-button-introjs-btn'),
    steps: [
      {
        element: '#js_header_history_button',
        popover: {
          description: __('header-toolbar-button-introjs'),
          side: 'bottom',
          align: 'end',
        },
      },
    ],
    onNextClick() {
      window.localStorage.setItem('introjsCtrlZ', 1);
      driverObj.destroy();
    },
  });

  driverObj.drive();
}

function keyPressCancel(e) {
  const evtobj = window.event ? event : e;

  if (e.key === 'Tab' && e.target.classList.contains('vgp_input_use_tab')) {
    return;
  }

  if ((evtobj.ctrlKey || evtobj.code === 'KeyZ') && !(routerHelper.isGanttRoute() || routerHelper.isMultiProjectsRoute())) {
    app.trigger('gantt:keyboard:disable');

    return;
  }

  if (((evtobj.ctrlKey || evtobj.keyCode === 224 || evtobj.keyCode === 17 || evtobj.keyCode === 91) || evtobj.metaKey) && evtobj.which === 90) {
    if (document.getElementsByClassName('driver-overlay').length > 0) {
      e.preventDefault();

      return;
    }

    if (!window.localStorage.getItem('introjsCtrlZ')) {
      startIntro();
    }
  }
}

export default {
  startIntro,
  keyPressCancel,
};
